import {auth0} from './index';
import AuthError from './AuthError';

let auth0Key;
let store;

const _getAuth0State = (state) => {
    if (!auth0Key) {
        auth0Key = Object.keys(state).find((key) => ('AUTH0_STORE' in state[key]));
    }

    if (!state[auth0Key]) {
        throw new AuthError('You are not logged in yet', 428);
    }

    return state[auth0Key];
};

export const secure = (callback) => (...props) => {
    const auth0state = _getAuth0State(store.getState());

    if (new Date().getTime() < auth0state.expiresAt) {
        return callback(...props);
    }

    throw new AuthError('Not allowed', 401);
};

export const handleAuthentication = () => auth0.handleAuthentication();

export const tokenIsValid = (expiryDate) => {
    const now = JSON.stringify(new Date().getTime());
    return (now < expiryDate);
};
